import { render, staticRenderFns } from "./DownloadableItem.vue?vue&type=template&id=061c46c7&"
import script from "./DownloadableItem.vue?vue&type=script&lang=js&"
export * from "./DownloadableItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports